import { useQuery } from '@tanstack/react-query';

import { intercultureQueries } from '../../data-access/queries/interculture';

import { useQueriesWithGlobal } from '@data-access';

interface Params {
  type: string;
}

export function useValues({ type }: Params) {
  const queries = useQueriesWithGlobal(intercultureQueries);

  const values = useQuery(queries.values({ crop: type }));

  return values;
}

export default useValues;
